import { NodeModel } from "../_model/NodeModel";
import { DecorationEvaporator2 } from "./decorationEvaporator2";
import { Types } from "../../utils/nodeTypes";
import Properties from "../_model/ModelEngineeringProperties";

class Evaporator2 extends NodeModel {
  constructor() {
    super("Evaporator2");

    this.type = new Types().Evaporator2;

    this.x = 0;
    this.y = 0;
    this.xImg = () => this.x + 2;
    this.yImg = () => this.y + 2;
    this.height = 130;
    this.width = 65;
    this.operationSelected = "";
    this.currentVapProd = null;
    this.showAmountOfSteam = false;
    this.srcImg = require("@/assets/Fluxogramas/evaporador.png");
    this.jokerCaption = [];
    this.data = [new Properties({ ...this })];

    this.decorate = async function(callback) {
      this.decorator = new DecorationEvaporator2();
      await this.decorator.init(this, callback);
    };

    this.clone = () => {
      let cloned = new Evaporator2();
      cloned.id = this.id;
      cloned.idName = this.idName;
      cloned.type = this.type;
      cloned.x = this.x;
      cloned.y = this.y;
      cloned.height = this.height;
      cloned.width = this.width;
      cloned.decorator = null;
      cloned.currentVapProd = this.currentVapProd;
      cloned.showAmountOfSteam = this.showAmountOfSteam;
      cloned.jokerCaption = this.jokerCaption
      cloned.readOnly = this.readOnly
      cloned.expressionVisible = this.expressionVisible;
      cloned.data = this.data.map(d => d.clone());

      return cloned;
    };

    this.copyFrom = (node) => {
      this.simpleCopyFrom(node);
      this.currentVapProd = node.currentVapProd;
      this.showAmountOfSteam = node.showAmountOfSteam;
      this.jokerCaption = node.jokerCaption
      this.data = node.data.map((d) => new Properties({ ...d }));
    };

    this.update = (node) => {
      this.showAmountOfSteam = node.showAmountOfSteam
      if (node.attrs) {
        this.data = node.attrs;
      }
      this.jokerCaption = node.jokerCaption;
      this.expressionVisible = node.expressionVisible;
      this.currentVapProd = node.currentVapProd;
    };
  }
}

export { Evaporator2 };
